import baseRequest from './useRequest';
import { _CSP_STORENFONT_TOKEN, _CSR_COMPANY_LOCATION } from '@/const/shopifyConst';
import { useGetStorage } from '@/hooks/common/useStorage';
import { cloneDeep } from "lodash-es";
import { useFormatGraphQLProductId } from '@/hooks/shopify-hooks/useShopifyUtils';
import { __SHOPIFY_PRODUCT_INFO__ } from '@/hooks/common/use-expose-csr-context/constants.js'
import useProductModelNumber from '@/hooks/common/product/useProductModelNumber';

const promiseCache = new Map();
// const storefrontToken = localStorage.getItem(_CSP_STORENFONT_TOKEN);
// const locationId = localStorage.getItem(_CSR_COMPANY_LOCATION);
const storefrontToken = useGetStorage(_CSP_STORENFONT_TOKEN);
const locationId = useGetStorage(_CSR_COMPANY_LOCATION)
console.log('===b2b==', storefrontToken, locationId)
const query = (storefrontToken && locationId) ?
  `query products($first: Int, $query: String, $buyer: BuyerInput,$cursor: String) @inContext(buyer: $buyer) {
  products(first: $first, query: $query,after: $cursor) {
    edges {
      cursor
      node {
        title
        tags
        id
        featuredImage {
          url
        }
        variants(first:10) {
          nodes {
            id
            availableForSale
            quantityAvailable
            quantityRule {
              maximum
              minimum
              increment
            }
            quantityPriceBreaks(first: 10) {
              nodes {
                minimumQuantity
                price {
                  amount
                  currencyCode
                }
              }
            }
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
` : `query products($first: Int, $query: String,$cursor: String) {
  products(first: $first, query: $query,after: $cursor) {
    edges {
      cursor
      node {
        title
        id
        description
        tags
        handle
        featuredImage {
          url
        }
        variants(first:10) {
          nodes {
            id
            availableForSale
            quantityAvailable
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
`;

const productByIdsQuery = `
  query getProductsByIds($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        title
        description
        tags
        handle
        vendor
        productType
        featuredImage {
          url
        }
        variants(first: 10) {
          nodes {
            id
            availableForSale
            quantityAvailable
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
  }

`
const singleProductByIdQuery = `
  query getProductById($id: ID!) {
    product(id: $id) {
      id
      title
      description
      tags
      handle
      vendor
      productType
      featuredImage {
        url
      }
      variants(first: 10) {
        nodes {
          id
          availableForSale
          quantityAvailable
          price {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
`
// 查询商品改成tag方式查询 (无缓存)
// export const useProductApi = async (productModel) => {
//   try {
//     const variables = {
//       first: 200,
//       query: `tag:${productModel}`
//     };
//     if (storefrontToken && locationId) {
//       variables.buyer = {
//         customerAccessToken: storefrontToken,
//         companyLocationId: locationId
//       };
//     }
//     const result = await baseRequest(query, variables);
//     if (result?.data?.products?.edges?.length) {
//       return {
//         data: {
//           product: result.data.products.edges[0].node
//         }
//       }
//     } else {
//       return {
//         data: {
//           product: null
//         }
//       }
//     }
//   } catch (e) {
//     console.log('error', e);
//     throw new Error("Error in fetching the products");
//   }
// }

// 查询商品改成tag方式查询 (有缓存)
export const useProductApi = async (productModel) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const variables = {
        first: 200,
        query: `tag:'${useProductModelNumber(productModel)}'`
      };
      if (storefrontToken && locationId) {
        variables.buyer = {
          customerAccessToken: storefrontToken,
          companyLocationId: locationId
        };
      }
      const cb = (result) => {
        const len = result?.data?.products?.edges?.length
        if (len > 0) {
          // 若是返回多个，过滤出tag和modelNumber完全匹配的商品
          const products = result?.data?.products?.edges.filter(item => {
            const targetTag = item.node.tags.find(tag => useProductModelNumber(tag) === useProductModelNumber(productModel));
            if (targetTag) {
              return item
            }
          })
          // 若是数据清洗后返回一个商品, 则返回这个商品
          if (products.length === 1) {
            const res = {
              data: {
                product: products[0].node
              }
            }
            resolve(res);
          } else {
            // 若是数据清洗后返回多个商品或者0个商品, 则返回null
            const res = {
              data: {
                product: null
              }
            }
            resolve(res);
          }          
        } else {
          const res = {
            data: {
              product: null
            }
          }
          resolve(res);
        }
      }
      await baseRequest(query, variables, 'product', cb);
    } catch (e) {
      console.log('error', e);
      reject(e);
      throw new Error("Error in fetching the products");
    }
  })
}

// models 传数组，[tag:MAW10V1QWT]
// 批量查询产品接口，注意若moderNumber含有特殊字符如（）：空格，会导致查询失败（返回为空）
export const useProductsApi = async(models, limit = 200) => {
  try {
    // 统一在这里将model number里面的空格去除，转成大写，加上tag: 
    const tagModels = models.map(item =>{
      item = useProductModelNumber(item);
      return `tag:'${item}'`;
    });

    const variables = {
      first: limit,
      query: `${tagModels.join(' OR ')}`
    };
    if (storefrontToken && locationId) {
      variables.buyer = {
        customerAccessToken: storefrontToken,
        companyLocationId: locationId
      };
    }
    let allProducts = [];
    let hasNextPage = true;
    let cursor = null;

    while (hasNextPage) {
      
      const result = await baseRequest(query, variables, "product");
      const products = result.data.products;

      allProducts = allProducts.concat(products?.edges?.map(edge => edge.node));
      hasNextPage = products.pageInfo.hasNextPage;

      if (hasNextPage) {
        cursor = products.edges[products.edges.length - 1].cursor;
        variables.cursor=cursor;
      }
    }

    // 以model number为key，将所有产品数据合并
    const modelToShopifyProductMap = {};
    allProducts?.forEach((item) =>{
      const { tags, variants, title } = item || {};
      const {
        id, // shopify product id
        availableForSale, // 是否在售
        quantityAvailable, // 库存
        compareAtPrice, // 原价
        price, // 售价
      } = variants?.nodes[0] || {};
      const a = tags.find((tag) => models.includes(useProductModelNumber(tag)));
      
      if (a) {
        modelToShopifyProductMap[useProductModelNumber(a)] = {
          id,
          availableForSale,
          quantityAvailable,
          compareAtPrice,
          price,
          productId: item?.id ? item?.id.split("/").pop() : null,
          title,
          shopifyProductId:item?.id,
        };
      }
    });

    console.log('allProducts: ', allProducts);
    console.log("modelToShopifyProductMap", modelToShopifyProductMap);
    return {
      allProducts,
      modelToShopifyProductMap,
    };
   
  } catch (e) {
    console.log('error', e);
    throw new Error("Error in fetching the products");
  }
}

// 通过产品id查询返回sku
export const useProductByIdApi = async(id) => {
    try {
      const query = `
        query getProductById($id: ID!) { 
          product(id: $id) { 
            title
            totalInventory
            variants(first:10) {
              edges {
                node {
                  title
                  sku
                }
              }
            } 
          } 
        }
      `;
      const variables = {
        id
      };
      const result = await baseRequest(query, variables);
      if (result?.data?.product?.variants?.edges?.length) {
        const res = result?.data?.product?.variants?.edges[0].node?.sku;
        return res;
      } else {
        return null
      }
    } catch(e) {
      console.log('error', e);
      throw new Error("Error in fetching the product by id");
    }
}

/**
 * 把产品信息以id为key存到window上
 * 
 * **/ 
const windowProductInfoOfId = {
  set(id, value) {
    if (window?.csr && !window?.csr?.[__SHOPIFY_PRODUCT_INFO__]) {
      window.csr[__SHOPIFY_PRODUCT_INFO__] = {};
    }
    window.csr[__SHOPIFY_PRODUCT_INFO__][id] = value;
  },
  get(id) {
    if (window?.csr?.[__SHOPIFY_PRODUCT_INFO__]?.[id]) {
      return window.csr[__SHOPIFY_PRODUCT_INFO__][id];
    }
    return null;
  }
}

/**
 * 根据产品ID列表获取产品信息
 * @param {Array} idList 产品ID列表 最大长度不应超过250
 * @returns {Promise<Array>} 产品信息列表
 * @throws {Error} 获取产品信息失败
 * @example await useProductByIdsApi(['8341535818036', '8341536833844', '9106986008884'])
 */

export const useProductByIdsApi = async (idList = []) => {
  // eslint-disable-next-line no-async-promise-executor
  if (!idList || !idList?.length) { return; }
  let allProduct = [];
  const ids = idList.map(item => useFormatGraphQLProductId(item));
  const idOrder = cloneDeep(ids); // 缓存id原始顺序
  const sortById = (objArr, idArr) => {
    const map = new Map(objArr.filter(item => item?.id).map(item => [item.id, item]));
    return idArr.map(id => map.get(id) ?? null);
  }
  // 优先取window缓存
  for (let i = ids.length - 1; i >= 0; i--) {
    const cache = windowProductInfoOfId.get(ids[i]);
    if (cache) {
      allProduct.push(cache);
      ids.splice(i, 1);
    }
  }
  // 缓存数据全满足，返回缓存数据
  if (!ids.length) {
    const sortAllProduct = sortById(allProduct, idOrder);
    console.log('cacheProduct: ', sortAllProduct);
    return sortAllProduct;
  }
  // 调用shopify storefront 接口获取商品
  try {
    const variables = {
      ids
    };
    const result = await baseRequest(productByIdsQuery, variables, "product");
    const nodes = result?.data?.nodes || [];
    allProduct = [...allProduct, ...nodes];
    // 写入window缓存
    nodes?.forEach(e => {
      if (e?.id) {
        windowProductInfoOfId.set(e.id, e);
      }
    });
    const sortAllProduct = sortById(allProduct, idOrder);
    console.log('apiAndCacheProducts: ', sortAllProduct);
    return sortAllProduct;
  } catch (e) {
    console.log('error', e);
    throw new Error("Error in fetching the products by id");
  }
}


/**
 * 根据产品ID获取对应单个产品信息
 * @param {string} id 商品ID
 * @returns {object} 商品信息
 * @example await useSingleProductByIdApi('8341535818036')
 */
export const useSingleProductByIdApi = async (id) => {
  // eslint-disable-next-line no-async-promise-executor
  if (!id) { return; }
  // 转成shopify全局id
  id =  useFormatGraphQLProductId(id);
  // 优先取window缓存
  const cache = windowProductInfoOfId.get(id);
  if (cache) {
    return cache;
  }
  // 优先读取请求缓存
  const apiCache = promiseCache.get(id);
  if (apiCache) {
    const res = await apiCache;
    const result = res?.data?.product || null;
    return result;
  }

  // 若缓存都没有，调用shopify storefront 接口获取商品
  try {
      const variables = {
        id
      };
      const api = baseRequest(singleProductByIdQuery, variables, "product");
      promiseCache.set(id, api);
      const res = await api;
      const result = res?.data?.product || {};
      promiseCache.delete(id);

      // 写入window缓存
      if (Object.keys(result).length) {
        windowProductInfoOfId.set(id, result);
      }
      return result;
    } catch (e) {
      console.log('error', e);
      throw new Error("Error in fetching the product by id");
    }
  }
// 通过产品ids查询返回sku（批量）
export const useBatchProductByIdApi = async(ids = []) => {
  try {
    const query = `
      query GetProductsById($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            title
            variants(first: 10) {
              edges {
                node {
                  id
                  sku
                  title
                }
              }
            }
          }
        }
      }
    `;
    const variables = {
      ids
    };
    const result = await baseRequest(query, variables);
    if (result?.data?.nodes?.length) {
      const skus = [];
      result?.data?.nodes.forEach(e => {
        skus.push(e?.variants?.edges[0].node?.sku)
      });
      return skus;
    } else {
      return null;
    }
  } catch(e) {
    console.log('error', e);
    throw new Error("Error in fetching the batch product by id");
  }
}

export default useProductApi;